
import React, { useEffect, useState } from 'react';
import { observer } from "mobx-react";
import { Button } from "@mui/material";
import Box from '@mui/material/Box/Box';

const UploadImgModal = observer(({ setImg }) => {
    const [widget, setWidget] = useState(undefined);

    const showWidget = async () => {
        setWidget(window.cloudinary.createUploadWidget({
            cloudName: "dwlzf32s3",
            uploadPreset: "fwyci7lc",
            multiple: false,
            cropping: true,
            showSkipCropButton: true,
            croppingAspectRatio: 1,
            maxFileSize: 3145728,
            stylesheet: "#cloudinary-widget .ReactCrop__crop-selection{border-radius: 100% !important;}",
            styles: {
                palette: {
                    window: "#ffffff",
                    sourceBg: "#f4f4f5",
                    windowBorder: "#90a0b3",
                    tabIcon: "#000000",
                    inactiveTabIcon: "#555a5f",
                    menuIcons: "#555a5f",
                    link: "#1D1761",
                    action: "#339933",
                    inProgress: "#0433ff",
                    complete: "#339933",
                    error: "#cc0000",
                    textDark: "#000000",
                    textLight: "#fcfffd"
                },
                fonts: {
                    default: null,
                    "'Fira Sans', sans-serif": {
                        url: "https://fonts.googleapis.com/css?family=Fira+Sans",
                        active: true
                    }
                }
            }
        }, (error, result) => {
            if (!error && result && result.event === "success") {
                setImg(result.info.url);
            }
        }));
    }

    useEffect(() => {

        if (widget) {
            widget.open();
        }

    }, [widget]);


    return (
        <Box sx={{height: '20px', mt: 2}}>
            <Button variant="contained" color='primary' onClick={showWidget} sx={{ ml: '20px', mb: '20px', mt: '20px' }}>
                Upload Image
            </Button>
        </Box>
    );


});

export default UploadImgModal;
